import React from "react";
import Tabs from 'material-ui/Tabs/Tabs';
import Tab from 'material-ui/Tabs/Tab';
import PageAncestor from "core/common/page/pageAncestor";
import mdEntityService from "core/metamodel/mdEntityService";
import productService from "product/productService";
import {preSave, IDomainObject, lovValue} from "core/form/formUtils";
import gridService from "core/grid/gridService";
import GridComp, {UILOCATION} from "core/grid/component/gridComp";
import Toolmenu from "core/components/toolmenu/toolmenu";
import {TabTemplate} from "core/common/config/mui-theme";
import {tabStyle} from "core/common/config/variables";
import {ErrorComp} from "core/components/errorComp/errorComp";
import ProductForm, {definition as ProductFormDefinition} from "product/component/productForm";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import Grid from 'core/grid/domain/grid';
import last = require("lodash/last");
import {MODULE, PERMISSION, PageProps, SECURABLE} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import {PRICECOMPLEVEL, PriceComponent, Product} from "product/productDomain";
import {MovingBlocks} from "core/grid/gridUtils";
import uiService from "core/common/service/uiService";
import {action, observable, ObservableMap} from "mobx";
import {History} from "react-router";
import {WithDeleteDialogZzFlatButton, ZzFlatButton} from "core/components/buttons/buttons";
import {BlockComp, MdBlockArray, MdDivider} from "core/components/blockComp/blockComp";
import {Address} from "party/partyDomain";
import MdEntity from "core/metamodel/mdEntity";
import {MdIconButton} from "core/components/buttons/icons";
import {addSeparator} from "core/common/utils/arrayUtils";
import Add from "material-ui/svg-icons/content/add";
import securityService from "core/security/securityService";
import PriceComponentProductForm from "product/component/priceComponentProductForm";
import {MdCheckbox} from "core/components/fields/fields";
import {isValid, sortAndCheckInterval} from "core/common/utils/dateUtils";
import moment from "moment";
import {GridDocument} from "core/document/gridDocument";
import GridDocumentComp from "core/document/component/gridDocumentComp";
import VatRateForm, {VatRateClosedContent, VatRateFormDefinition} from "../../invoice/component/vatRateForm";
import {loc} from "../../core/common/config/locales";




const vehicleGridLocation = 'productVehicleList';
const invoiceGridLocation = 'productInvoiceList';
const invoiceItemGridLocation = 'productInvoiceItemList';
const productGridDocument = 'productGridDocument';


@observer
export default class ProductDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.product;
  static title = 'Product';
  static icon = 'cube';
  static protectedPage = true;

  @observable savedProduct;


  static fetchData(routerParams, query) {
    console.log("ProductDetail#fetchData(%O)", query);

    let metadataPromise = mdEntityService.fetchEntityMetadata(['Product', 'PriceComponent'], ["Document"]);

    let productPromise: Promise<Product>;

    if (routerParams.id === 'new') {
      productPromise = Promise.resolve(new Product(Object.assign({$new: true, active: true}, query)));
    } else if (routerParams.id === 'copy') {
      productPromise = productService.readProduct(query.copyId)
        .then(productObject => {
          productObject.cleanOnCopy();
          productObject.active = true;
          return productObject;
        })
    } else {
      productPromise = productService.readProduct(routerParams.id);
      // Needed for show history
      mdEntityService.setFormDefinition(VatRateFormDefinition.formName, VatRateFormDefinition)
      mdEntityService.setClosedContent(VatRateFormDefinition.formName, VatRateClosedContent)
    }

    let gridPromise = gridService.fetchGrids(vehicleGridLocation, invoiceGridLocation, invoiceItemGridLocation);

    return Promise.all([metadataPromise, productPromise, gridPromise])
      .then( ([entityMap, productObject, gridLocationMap]: [any, Product, any]) => {

        productObject.$movingBlocks = new MovingBlocks(vehicleGridLocation, true, query.tab,
          new Grid(gridLocationMap.get(vehicleGridLocation), productObject.productId),
          new Grid(gridLocationMap.get(invoiceGridLocation), productObject.productId),
          new Grid(gridLocationMap.get(invoiceItemGridLocation), productObject.productId),
          new GridDocument(productGridDocument, "Docs", {productId: productObject.productId}, false, null, (productObject.$new)?[]:null)
        );

        productService.productObject = productObject.initAfterRead(routerParams.id === 'new');
      });
  }




  /**
   *
   */
  componentWillMount() {
    uiService.addMediaQueryListener(this.mediaQueryListener);
  }


  /**
   * tohle je tady kvuli prechodu na jiny detail productu (chained details)
   * @param prevProps
   */
  componentDidUpdate(prevProps: PageProps) {
    if(this.idChanged(prevProps.params.id, this.props.params.id)) {
      productService.productObject.$movingBlocks.searchExposedGrids(productService.vehicleObject);
    }
  }

  componentDidMount() {
    console.debug("%c componentDidMount", "background-color: magenta");
    productService.productObject.$movingBlocks.searchExposedGrids(productService.productObject);
  }

  componentWillUnmount() {
    uiService.removeMediaQueryListener(this.mediaQueryListener);
    productService.productObject = null;
  }



  customValidate = (productObject: Product) => {
    let errors = [];

    const productForm = productObject.getForm(ProductFormDefinition.formName);
    if (productForm.fields.productNumber.props.errorText) {
      errors.push({propertyPath: "productNumber", message: productForm.fields.productNumber.props.errorText});
    }

    const pricesPerCurrency: {[curr: string]: PriceComponent[]} = productObject.prices.reduce((acc, price) => {
      let currEntry = acc[lovValue(price.priceCurrency)];
      if (!currEntry) {
        currEntry = [];
        acc[lovValue(price.priceCurrency)] = currEntry;
      }
      currEntry.push(price);
      return acc;
    }, {});

    for(let currency in pricesPerCurrency) {
      let currEntry = pricesPerCurrency[currency];
      if (!sortAndCheckInterval(currEntry)) {
        errors.push({propertyPath: "prices", message: "Price validity intervals for " + currency + " must not overlap"});
      }
    }



    return errors;
  };


  findRootObject() {
    return productService.productObject;
  }

  @action onSave = (evt) => {
    console.log('onSave ');
    uiService.showToolbarActionFlag();

    let result = preSave(productService.productObject, this.customValidate);
    if (!result) {
      return;
    }

    let wasNew: boolean;

    return productService.productSave(productService.productObject)
      .then( action("productSave-callback", (productJson: IDomainObject) => {
        if (!this.savedProduct) {
          this.savedProduct = Math.floor((Math.random() * 100) + 1);
        }
        else {
          this.savedProduct =  this.savedProduct + 1;
        }
        wasNew = productService.productObject.cleanAfterSave(productJson);
        return this.docSavingPromise(productService.productObject.$movingBlocks.getBlock(productGridDocument) as GridDocument, {productId: productService.productObject.productId});
      })).then(x => {
          if (wasNew) {
          this.context.router.replaceWith('productDetail', {id: productService.productObject.productId});
        }
        uiService.hideToolbarActionFlag();
    }).catch(error => {
      productService.productObject.$errors = error.getMessages();
    });

  };


  @action onDelete = (evt) => {
    console.log('onDelete');

    uiService.showToolbarActionFlag();

    productService.deleteProduct(productService.productObject.productId)
      .then(response => {
        uiService.hideToolbarActionFlag();
        this.goBackOrHome();
      }, error => {
        productService.productObject.$errors = error.getMessages();
      });
  };



  onAdd = (evt) => {
    console.log('onAdd');
    let query = {};
    this.context.router.transitionTo("productDetail", {id: 'new'}, query);
  };

  onCopy = (evt) => {
    console.log('onCopy');
    this.context.router.transitionTo("productDetail", {id: 'copy'}, {copyId: productService.productObject.productId});
  };



  render() {

    let {
      query
      } = this.props;

    let propsForCreateForm = {
      dataObject: productService.productObject,
      rootObject: productService.productObject,
      entity: mdEntityService.getEntity('Product'),
      entities: mdEntityService.entityMap
    };

    console.debug('%c productDetail render query %O', 'background-color: yellow', this.props.query);

    const mainForm = (
      <form style={{marginTop: 10}}>
        <MdBlockArray inset>
          { [
            <ProductForm {...propsForCreateForm} key={"PF" + this.savedProduct ? this.savedProduct : 1}  />,
            <ProductPriceList productObject={productService.productObject} entities={mdEntityService.entityMap} key={2}/>
          ] }
        </MdBlockArray>
      </form>
    );

    let movingBlocks = productService.productObject.$movingBlocks;

    const gridCompArray = [
      <GridComp grid={movingBlocks.getBlock(vehicleGridLocation) as Grid} uiLocation={movingBlocks.getUiLocation(vehicleGridLocation)}
                entities={mdEntityService.entityMap} multiUpdateSecurable={SECURABLE.productGridUpdate} />,
      <GridComp grid={movingBlocks.getBlock(invoiceGridLocation) as Grid} uiLocation={movingBlocks.getUiLocation(invoiceGridLocation)}  entities={mdEntityService.entityMap}/>,
      <GridComp grid={movingBlocks.getBlock(invoiceItemGridLocation) as Grid} uiLocation={movingBlocks.getUiLocation(invoiceItemGridLocation)} entities={mdEntityService.entityMap}/>,
      <GridDocumentComp uiLocation={movingBlocks.getUiLocation(productGridDocument)} grid={movingBlocks.getBlock(productGridDocument) as GridDocument}
                        entities={mdEntityService.entityMap} rootObject={productService.productObject}/>
    ];

    const standAloneGridComp = movingBlocks.pluckStandAloneBlock(gridCompArray);

    const tabArray = gridCompArray.map(gridComp => (
      <Tab label={gridComp.props.grid.label} style={tabStyle} onActive={this.activateTab.bind(this, gridComp.props.grid)} key={gridComp.props.grid.getBlockName()}  value={gridComp.props.grid.getBlockName()}>
        {gridComp}
      </Tab>
    ));


    const tabs = (tabArray.length) ? (
      <Tabs value={movingBlocks.activeBlockTab} className="detail-grid" tabTemplate={TabTemplate} inkBarStyle={{transition: 'inherit'}}
            contentContainerStyle={{width: '100%', flexGrow: 1, display: 'flex', minHeight: 0}} onChange={this.onTabChange} >
        {tabArray}
      </Tabs>
    ) : '';



    if (uiService.globalMediaQuery.matches) {
      return (
        <main className="main-content" style={{display: 'flex', flexDirection: 'row'}} >
          <div style={{display: 'flex', flexDirection: 'column', height: '100%', width:'50%'}}>
            {this._createToolMenu(productService.productObject, query.gridLocation)}
            <ErrorComp messages={productService.productObject.$errors} />
            <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
            <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>
            {mainForm}
            {tabs}
          </div>
          {standAloneGridComp}
        </main>
      );
    } else {
      return (
        <main className="main-content" style={{display: 'flex', flexDirection: 'column'}} >
          {this._createToolMenu(productService.productObject, query.gridLocation)}
          <ErrorComp messages={productService.productObject.$errors} />
          <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
          <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>
          {mainForm}
          {tabs}
        </main>
      );
    }
  }




  _createToolMenu(productObject, gridLocation) {
    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onBack} backDisabled={History.length <= 1} historize entityName="Product"
                entityId={productObject.productId} activeTab={productObject.$movingBlocks.activeBlockTab}>
        <ZzFlatButton onClick={this.onSave} disabled={!productObject.$dirty} label="Save" permission={productObject.$new ? PERMISSION.New : PERMISSION.Update}/>
        <ZzFlatButton onClick={this.onAdd} disabled={productObject.$new} label="New" permission={PERMISSION.New}/>
        <ZzFlatButton onClick={this.onCopy} disabled={productObject.$new} label="Copy" permission={PERMISSION.New}/>
        <WithDeleteDialogZzFlatButton entityName="Product" pageAncestor={this} onClick={this.onDelete} disabled={productObject.$new} label="Delete" permission={PERMISSION.Delete}/>
      </Toolmenu>
    );
  }


}


interface ProductPriceListProps {
  productObject: Product;
  entities: ObservableMap<MdEntity>;
}

@observer
class ProductPriceList extends React.Component<ProductPriceListProps, undefined> {

  @observable private showAll: boolean;
  private now: moment.Moment = moment().startOf('day');

  @action addPrice = () => {
    console.debug('addPrice');
    const {productObject, entities} = this.props;
    let newPrice = new PriceComponent({
      $new: true,
      $added: true,
      priceLevel: entities.get("PRICECOMPLEVEL").getLovItem(PRICECOMPLEVEL.PRODUCT),
      product: productObject.createLov(),
      priceCurrency: securityService.currentTenant.defaultCurrency
    }).initDefaultValues();
    productObject.prices.push(newPrice);
    productObject.$dirty = true;
  };

  @action onShowAll = (evt) => {
    this.showAll = evt.target.checked;
  };


  render() {

    const {productObject, entities} = this.props;


    const header = (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <div>Prices</div>
        <MdIconButton onClick={this.addPrice}>
          <Add />
        </MdIconButton>
      </div>
    );

    return (
      <BlockComp header={header} noPadding={true} style={{display: 'flex', flexDirection: 'column'}}>
        {
          productObject.prices.filter(price => this.showAll || isValid(price, this.now)).map((price, index) => <PriceComponentProductForm dataObject={price}
                                                                                   rootObject={productObject}
                                                                                   key={index}
                                                                                   entities={entities}
                                                                                   entity={entities.get('PriceComponent')}
                                                                                   index={index}/>)
        }
        <MdCheckbox label="Show invalid prices" checked={this.showAll} labelStyle={{whiteSpace: 'nowrap', marginRight: 5, fontSize: 13}} style={{width: 'initial', marginLeft: 10, marginTop: 10}} iconStyle={{height: 18, paddingTop: 2}} labelPosition="left" onCheck={this.onShowAll} />
      </BlockComp>
    );
  }
}



// WEBPACK FOOTER //
// ./src/product/page/productDetail.tsx